import { snakeCase } from 'lodash'
import { createChildActions } from 'helpers/actions'
import entityNames from 'options/entityNames'
import { createOrphanedChildPost } from 'helpers/api'

const entityName = entityNames.rfqs
const ENTITY_NAME = snakeCase(entityName).toUpperCase()

const childName = 'rfqItems'
const CHILD_NAME = snakeCase(childName).toUpperCase()

export default {
  ...createChildActions(entityName, childName),

  populateRfqItems: (params) => ({
    type: `${ENTITY_NAME}_${CHILD_NAME}_POPULATE`,
    payload: createOrphanedChildPost(entityName, childName, { action: 'populate' })(params),
  }),
}
